// Helper function to construct API URLs
export const apiUrl = (path) => {
    // Use environment variable if available, otherwise default to localhost:5000
    const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
    return `${baseUrl}${path}`;
};

// Export the base URL itself if needed
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
